var map = {
	"./Casino.webp": 1688,
	"./Cricket.webp": 2236,
	"./Election.webp": 2237,
	"./Fantasy.webp": 1689,
	"./Finance-Trading.webp": 1171,
	"./Horse-Racing.webp": 1170,
	"./Inplay.webp": 2238,
	"./Live-Card.webp": 2239,
	"./Live-Cards.webp": 1690,
	"./Live-Casino.webp": 2240,
	"./Premium-Notebook.webp": 2241,
	"./Slot-game.webp": 1691,
	"./Soccer.webp": 2242,
	"./Sportsbook.webp": 2243,
	"./Tennis.webp": 2244,
	"./fantasybookicon.webp": 1692,
	"./fundlist.webp": 1693,
	"./greyhound.webp": 2245,
	"./horse.webp": 1087,
	"./more.webp": 2246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1549;